import WidgetRegistrations from './WidgetRegistrations';

export default WidgetRegistrations;
